module.exports = __webpack_public_path__ + "static/media/homebg.3f02cd5b.svg";